import Vue from 'vue'
import App from './App.vue'
import Axios from 'axios'
import './registerServiceWorker'
import router from './router'
import './assets/tailwind.css'
import VueMeta from 'vue-meta'
import store from './store'

const mode = process.env.MODE_ENV

Vue.config.productionTip = false
Vue.prototype.$http = Axios.create({
  baseURL: mode
})

Vue.use(VueMeta)

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
